import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { EmissionsAggregated } from 'walden-fast/types/fast-backend/emissions-aggregated';
import KpiService from 'walden-fast/services/kpi';
import UserService from 'walden-fast/services/user';
import { SERVICE_NAMES } from 'walden-fast/utils/constants/services';
import type FastApiService from 'walden-fast/services/fast-api';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AppServicesWaldenGreenModel = Resolved<
  ReturnType<AppServicesWaldenGreenRoute['model']>
>;

export default class AppServicesWaldenGreenRoute extends Route {
  @service('fast-api') declare fastApiService: FastApiService;
  @service('kpi') declare kpiService: KpiService;
  @service('user') declare userService: UserService;

  async model() {
    const userCanAccessLevel0 = this.userService.canAccessService(
      SERVICE_NAMES.WALDEN_GREEN_LEVEL0,
    );

    const userCanAccessService =
      this.userService.canAccessService(SERVICE_NAMES.WALDEN_GREEN_LEVEL1) ||
      this.userService.canAccessService(SERVICE_NAMES.WALDEN_GREEN_LEVEL2) ||
      this.userService.canAccessService(SERVICE_NAMES.WALDEN_GREEN_LEVEL3);

    const kpiStats = userCanAccessService
      ? await this.kpiService.getStatsForPage('Walden Green')
      : [];

    const emissionsAggregated = userCanAccessService
      ? await this.fastApiService.get<EmissionsAggregated>(
          '/walden-green/emissions/aggregated',
        )
      : null;

    return {
      userCanAccessLevel0,
      userCanAccessService,
      kpiStats,
      emissionsAggregated,
    };
  }
}
